import * as React from 'react';
import {cn} from '../lib/cn';

export function EmptyDescription({className, ...props}: React.ComponentProps<'p'>) {
  return (
    <div
      data-slot="empty-description"
      className={cn(
        'text-sm/relaxed text-[var(--chekin-color-gray-1)] [&>a:hover]:text-[var(--chekin-color-brand-blue)] [&>a]:underline [&>a]:underline-offset-4',
        className,
      )}
      {...props}
    />
  );
}
